import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useMe } from '@/auth/useAuth';
import { api } from '@/lib/api';
import { usePortalLocale } from '@/lib/i18n/PortalLocaleContext';
import { MemoryPanel } from './MemoryPanel';
export function DesktopMemoryPage() {
  const { t } = usePortalLocale();
  const me = useMe();
  const [kidId, setKidId] = useState('');
  const familyId = me.data?.kind === 'user' ? me.data.family_id : null;
  const kids = useQuery({
    queryKey: ['memory-kids', familyId],
    queryFn: () =>
      api<{ id: string; nickname: string }[]>(`/families/${familyId}/kids`, { principal: 'user' }),
    enabled: Boolean(familyId),
  });
  return (
    <div className="space-y-5">
      <h1 className="section-heading">{t('Hangar memory')}</h1>
      <label className="block">
        {t('Choose whose memory to manage')}
        <select
          className="input-field ml-3"
          value={kidId}
          onChange={(event) => setKidId(event.target.value)}
        >
          <option value="">{t('My memory')}</option>
          {kids.data?.map((kid) => (
            <option key={kid.id} value={kid.id}>
              {kid.nickname}
            </option>
          ))}
        </select>
      </label>
      {kids.isError && <p role="alert">{t('Could not load your children.')}</p>}
      <MemoryPanel key={`${me.data?.sub}:${kidId}`} kidId={kidId || undefined} />
    </div>
  );
}
